import React from 'react'
import PropTypes from 'prop-types'
import './Map.scss'

const Map = ({ loading, className }) => (
  <div id='map' className={`sl-map sl-map--loading-${loading} ${className}`} tabIndex='-1' />
)

Map.propTypes = {
  loading: PropTypes.bool,
  className: PropTypes.string
}

export default Map



// WEBPACK FOOTER //
// ./src/components/Map/Map.jsx